import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';
import styles from './LeagueCountdown.module.css';

const calculateTimeLeft = (endDate) => {
    const difference = +new Date(endDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
        timeLeft = {
            days: Math.floor(difference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
            total: difference,
        };
    }

    return timeLeft;
};

const LeagueCountdown = ({ startDate, endDate, onExpired }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(endDate));
    const [countdownColorClass, setCountdownColorClass] = useState('early');
    const [hasExpired, setHasExpired] = useState(false);

    useEffect(() => {
        const updateCountdownColor = () => {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const now = new Date();

            const totalDuration = end - start;
            const timePassed = now - start;
            const percentPassed = Math.min(Math.max(timePassed / totalDuration, 0), 1);

            // Liga: 3 kolory wg procentu upływu rundy
            // 0-35% zielony, 36-70% pomarańczowy, 71-100% czerwony
            if (percentPassed >= 0.71) {
                setCountdownColorClass('late');
            } else if (percentPassed >= 0.36) {
                setCountdownColorClass('mid');
            } else {
                setCountdownColorClass('early');
            }
        };

        updateCountdownColor();
        const interval = setInterval(updateCountdownColor, 60000);
        return () => clearInterval(interval);
    }, [startDate, endDate]);

    useEffect(() => {
        setHasExpired(false);
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft(endDate);
            if (!newTimeLeft.total || newTimeLeft.total <= 0) {
                clearInterval(timer);
                setTimeLeft({});
                if (!hasExpired && onExpired) {
                    setHasExpired(true);
                    onExpired();
                }
            } else {
                setTimeLeft(newTimeLeft);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [endDate]);

    if (!timeLeft.total || timeLeft.total <= 0) {
        return null;
    }

    // Ostatni dzień rundy (dzień + miesiąc po polsku, np. "21 czerwca") — z daty końca
    // rundy ustawionej przez administratora. Spójne z celem, do którego liczy countdown.
    const endDayLabel = endDate ? format(new Date(endDate), 'd MMMM', { locale: pl }) : '';

    return (
        <div className={styles.wrapper}>
            <div className={styles.label}>
                {`Czas do końca rundy${endDayLabel ? ` (${endDayLabel})` : ''}:`}
            </div>
            <div className={`${styles.countdownContainer} ${styles[countdownColorClass]}`}>
                <div className={styles.timeBox}>
                    <span>{timeLeft.days}</span>
                    <div className={styles.timeLabel}>dni</div>
                </div>
                <div className={styles.timeBox}>
                    <span>{timeLeft.hours}</span>
                    <div className={styles.timeLabel}>godzin</div>
                </div>
                <div className={styles.timeBox}>
                    <span>{timeLeft.minutes}</span>
                    <div className={styles.timeLabel}>minut</div>
                </div>
                <div className={styles.timeBox}>
                    <span>{timeLeft.seconds}</span>
                    <div className={styles.timeLabel}>sekund</div>
                </div>
            </div>
        </div>
    );
};

export default LeagueCountdown;
